import { z } from 'zod'

import { FORM_OPTIONAL_MESSAGE_MAX_CHARACTERS } from 'Components/FormOptionalMessage/FormOptionalMessage.constants'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

import { CancellationTypeEnum } from './CancelDeviceModal.types'

export const cancelDeviceModalFormSchema = z
  .object({
    cancellationType: z.nativeEnum(CancellationTypeEnum).nullable(),
    message: z
      .string()
      .max(FORM_OPTIONAL_MESSAGE_MAX_CHARACTERS, FORM_MESSAGES_MAP.MAX_LENGTH),
    scheduledDate: z.date().nullable(),
  })
  .refine(
    data => {
      // If scheduled, date is required
      if (data.cancellationType === CancellationTypeEnum.SCHEDULED) {
        return data.scheduledDate !== null
      }

      return true
    },
    {
      message: FORM_MESSAGES_MAP.REQUIRED,
      path: ['scheduledDate'],
    },
  )
